import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import ProductShowcase from '../../components/cultivars/IslandPink/ProductShowcase'
import Footer from '../../components/Footer'
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from 'react-helmet'

const IslandPink = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
    <Helmet>
        <title>Island Pink - Tropical Delight with Floral & Fruity Notes | BeyondBloom™</title>
        <meta
          name="description"
          content="Experience Island Pink, a tropical delight with floral and fruity notes. A premium cannabis cultivar for an uplifting and flavorful experience."
        />
        <meta
          name="keywords"
          content="Island Pink strain, cannabis, tropical cultivar, floral notes, fruity flavor, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Island Pink - Tropical Delight with Floral & Fruity Notes | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Experience Island Pink, a tropical delight with floral and fruity notes. A premium cannabis cultivar for an uplifting and flavorful experience."
        />
        <meta property="og:image" content="/images/pink-kush.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/island-pink" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Island Pink - Tropical Delight with Floral & Fruity Notes | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Experience Island Pink, a tropical delight with floral and fruity notes. A premium cannabis cultivar for an uplifting and flavorful experience."
        />
        <meta name="twitter:image" content="/images/pink-kush.png" />
      </Helmet>
    <Navbar/>
    <ProductShowcase/>
    <FeatureHighlight/>
    <CultivarDisplay />
    <Cta />
    <Footer/>
</>
  )
}

export default IslandPink